import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function OperationalEfficiencyMetrics({ operationalEfficiencyMetrics }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // useEffect(() => {
  //   const rawData = successMessage?.operational_efficiency_metrics;

  //   const dummyData = rawData
  //     ? Object.entries(rawData).map(([competitor, details]) => ({
  //         competitor,
  //         production_efficiency: details["Production Efficiency"] || "",
  //         lean_process_adoption: details["Lean Process Adoption"] || "",
  //         cost_optimization_strategy:
  //           details["Cost Optimization Strategy"] || "",
  //         production_efficiency_positive_insight:
  //           details["Production Efficiency"] || "",
  //         production_efficiency_negative_insight:
  //           details["Production Efficiency"] || "",
  //         production_efficiency_recent_development:
  //           details["Production Efficiency"] || "",
  //         lean_process_adoption_positive_insight:
  //           details["Lean Process Adoption"] || "",
  //         lean_process_adoption_negative_insight:
  //           details["Lean Process Adoption"] || "",
  //         lean_process_adoption_recent_development:
  //           details["Lean Process Adoption"] || "",
  //         cost_optimization_strategy_positive_insight:
  //           details["Cost Optimization Strategy"] || "",
  //         cost_optimization_strategy_negative_insight:
  //           details["Cost Optimization Strategy"] || "",
  //         cost_optimization_strategy_recent_development:
  //           details["Cost Optimization Strategy"] || "",
  //       }))
  //     : [];

  //   setTabData(dummyData);
  // }, [successMessage]);

  // Columns for GenericTable

  useEffect(() => {
    const tableData = transformResultsToTableData(operationalEfficiencyMetrics);
    setTabData(tableData);
  }, [operationalEfficiencyMetrics]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "production_efficiency", label: "Production Efficiency" },
    { key: "lean_process_adoption", label: "Lean Process Adoption" },
    { key: "cost_optimization_strategy", label: "Cost Optimization Strategy" },
  ];

  return (
    <InsightTable
      title="Operational Efficiency Metrics"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default OperationalEfficiencyMetrics;
